var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Component, Children, isValidElement, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { createRenderer as createFelaRenderer } from 'fela';
import prefixer from 'fela-plugin-prefixer';
import fallbackValue from 'fela-plugin-fallback-value';
import unit from 'fela-plugin-unit';
import lvha from 'fela-plugin-lvha';
import validator from 'fela-plugin-validator';
import embedded from 'fela-plugin-embedded';
import beautifier from 'fela-beautifier';
import monolithic from 'fela-monolithic';
import { Provider } from 'react-fela';
import { variables } from 'cf-style-const';
import { ThemeProvider } from 'cf-style-container';

var defaultOpts = {
  selectorPrefix: 'cf-',
  dev: false
};

export var createRenderer = function createRenderer(opts) {
  var usedOpts = Object.assign({}, defaultOpts, opts);
  var plugins = [prefixer(), fallbackValue(), unit(), lvha(), embedded()];
  var enhancers = [];

  if (usedOpts.dev === true) {
    plugins.push(validator());
    enhancers.push(beautifier());
    enhancers.push(monolithic());
  }

  return createFelaRenderer({
    plugins: plugins,
    enhancers: enhancers,
    selectorPrefix: [usedOpts.selectorPrefix]
  });
};

var StyleProvider = function StyleProvider(_ref) {
  var selectorPrefix = _ref.selectorPrefix,
      dev = _ref.dev,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['selectorPrefix', 'dev', 'children']);

  var renderer = createRenderer({
    selectorPrefix: selectorPrefix,
    dev: dev
  });
  var child = Children.only(children);
  return React.createElement(
    Provider,
    { renderer: renderer },
    React.createElement(
      ThemeProvider,
      { theme: variables },
      isValidElement(child) ? cloneElement(child, _extends({}, restProps)) : child
    )
  );
};

export { StyleProvider };
StyleProvider.defaultProps = defaultOpts;
StyleProvider.propTypes = {
  dev: PropTypes.bool,
  selectorPrefix: PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-style-provider/es/index.js
// module id = 732
// module chunks = 0